import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { PageHeader } from '@/shared/components/PageHeader';
import { Spinner } from '@/shared/components/Spinner';
import { EmptyState } from '@/shared/components/EmptyState';
import { Button } from '@/shared/components/Button';
import { Modal } from '@/shared/components/Modal';
import { RegisterPaymentForm } from '@/features/director-payments/components/RegisterPaymentForm';
import { PaymentsList } from '@/features/director-payments/components/PaymentsList';
import { useMyProfessor } from '../hooks/useMyProfessor';
/**
 * Cobros page for professors with the can_collect_payments permission. Same
 * collection tooling as the director (register + list, all students) but
 * without the financial analytics dashboard.
 */
export function ProfessorPaymentsPage() {
    const { data: professor, isLoading } = useMyProfessor();
    const [registerOpen, setRegisterOpen] = useState(false);
    if (isLoading) {
        return (_jsx("div", { className: "flex h-64 items-center justify-center", children: _jsx(Spinner, { size: "lg" }) }));
    }
    // Backend enforces this too (assertCanCollect); the UI guard avoids showing
    // tooling the professor can't use.
    if (!professor?.can_collect_payments) {
        return (_jsxs("div", { children: [_jsx(PageHeader, { title: "Cobros" }), _jsx(EmptyState, { icon: "credit-card", title: "Sin permiso de cobros", description: "No tienes habilitado el cobro de mensualidades. Contacta con la direcci\u00F3n." })] }));
    }
    return (_jsxs("div", { children: [_jsx(PageHeader, { title: "Cobros", action: _jsx(Button, { onClick: () => setRegisterOpen(true), children: "+ Registrar pago" }) }), _jsx(PaymentsList, {}), _jsx(Modal, { open: registerOpen, onClose: () => setRegisterOpen(false), title: "Registrar pago", children: _jsx(RegisterPaymentForm, { onSuccess: () => setRegisterOpen(false) }) })] }));
}
//# sourceMappingURL=ProfessorPaymentsPage.js.map